import * as React from "react";
import { useContext } from "react";
import Webpush from "../Webpush/Webpush";
var WebpushHandler = new Webpush(window.paramW, window.paramWS, "/rest/webpush/endpoint", window.vapidPublicKey);
export var WebpushContext = /*#__PURE__*/React.createContext(null);
export var WebpushProvider = function (_a) {
  var children = _a.children;
  return /*#__PURE__*/React.createElement(WebpushContext.Provider, {
    value: WebpushHandler
  }, children);
};
export var useWebpushValue = function () {
  return useContext(WebpushContext);
};